import actionsTypes from '../constants/ActionsTypes';

const actions = {
  setGaleriaImagem: (show, onImageSelect) => ({
    type: actionsTypes.SET_GALERIA_IMAGEM,
    show,
    onImageSelect
  })
};

export default actions;
